// extracted by mini-css-extract-plugin
export default {"dot":"mgIRLhvZuMMrsLoqT_04","active":"RgoeW8bAhOTmb2jLUFsR"};